import { render, staticRenderFns } from "./PigeDate.vue?vue&type=template&id=1f8a3dbe&"
import script from "./PigeDate.vue?vue&type=script&lang=ts&"
export * from "./PigeDate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports